import React from 'react';
import { Button } from '@/components/ui/button';
import { FileText, BarChart3, ShieldCheck, Users, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

interface WelcomeProps {
  userName: string;
  onNext: () => void;
}

const VALUE_POINTS = [
  {
    icon: FileText,
    text: 'Estruturar contratos complexos de forma clara e organizada',
  },
  {
    icon: BarChart3,
    text: 'Acompanhar o progresso das medições e entregas em tempo real',
  },
  {
    icon: ShieldCheck,
    text: 'Monitorar riscos e conformidade contratual com inteligência',
  },
  {
    icon: Users,
    text: 'Garantir transparência entre construtoras, contratantes e financiadores',
  },
];

const item = {
  hidden: { opacity: 0, y: 12 },
  show: { opacity: 1, y: 0 },
};

export const OnboardingWelcome: React.FC<WelcomeProps> = ({ userName, onNext }) => (
  <motion.div
    className="space-y-5"
    initial="hidden"
    animate="show"
    variants={{ show: { transition: { staggerChildren: 0.08 } } }}
  >
    <motion.div variants={item} className="text-center space-y-2">
      <h2 className="text-2xl font-bold tracking-tight">
        Bem-vindo ao NetUno{userName ? `, ${userName.split(' ')[0]}` : ''}
      </h2>
      <p className="text-sm text-muted-foreground leading-relaxed max-w-lg mx-auto">
        A plataforma de referência para gestão e execução de contratos de engenharia e infraestrutura.
      </p>
    </motion.div>

    <div>
      <motion.p variants={item} className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-2.5">
        Com o NetUno, você pode:
      </motion.p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
        {VALUE_POINTS.map(({ icon: Icon, text }) => (
          <motion.div
            key={text}
            variants={item}
            className="flex items-start gap-3 p-3 rounded-xl bg-muted/40 border border-border/40 hover:border-primary/20 transition-colors"
          >
            <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center mt-0.5">
              <Icon className="w-4 h-4 text-primary" />
            </div>
            <p className="text-[13px] text-foreground leading-snug">{text}</p>
          </motion.div>
        ))}
      </div>
    </div>

    <motion.p variants={item} className="text-xs text-muted-foreground text-center leading-relaxed">
      Nosso objetivo é ajudá-lo a ter <strong>controle</strong>, <strong>visibilidade</strong> e{' '}
      <strong>confiança</strong> na execução de cada contrato, do planejamento à conclusão.
    </motion.p>

    <motion.div variants={item}>
      <Button onClick={onNext} className="w-full group" size="lg">
        Começar configuração
        <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
      </Button>
    </motion.div>
  </motion.div>
);
